import { render, staticRenderFns } from "./ContactConsultantRelationSettingsUpdateForm.vue?vue&type=template&id=e3b26952"
import script from "./ContactConsultantRelationSettingsUpdateForm.vue?vue&type=script&lang=js"
export * from "./ContactConsultantRelationSettingsUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports